import React from 'react';

interface QuotaDetails {
  used: {
    '720p': number;
    '1080p': number;
    '4K': number;
    'satellite'?: number;
  };
  limits: {
    '720p': number;
    '1080p': number;
    '4K': number;
    'satellite'?: number;
  };
}

interface QuotaBarProps {
  quota: QuotaDetails | null;
}

export const QuotaBar: React.FC<QuotaBarProps> = ({ quota }) => {
  if (!quota) return null;

  const isLimitReached = (used: number, limit: number) => {
    return limit !== Infinity && limit !== null && limit !== -1 && used >= limit;
  };

  const renderLimitValue = (limit: number) => {
    return limit === Infinity || limit === null || limit === -1 ? '∞' : limit;
  };

  return (
    <div
      style={{
        background: 'rgba(15, 23, 42, 0.3)',
        borderBottom: '1px solid var(--border-glass)',
        padding: '10px 24px',
        backdropFilter: 'blur(10px)',
      }}
    >
      <div
        className="container"
        style={{
          display: 'flex',
          gap: '20px',
          alignItems: 'center',
          fontSize: '12px',
          color: 'var(--text-secondary)',
        }}
      >
        <span style={{ fontWeight: 700, color: '#fff', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
          Monthly Quota:
        </span>

        <div style={{ display: 'flex', gap: '16px' }}>
          <div>
            <span>720p: </span>
            <strong
              style={{
                color: isLimitReached(quota.used['720p'], quota.limits['720p'])
                  ? 'var(--status-error)'
                  : '#fff',
              }}
            >
              {quota.used['720p']} / {renderLimitValue(quota.limits['720p'])}
            </strong>
          </div>

          <div>
            <span>HD (1080p): </span>
            <strong
              style={{
                color: isLimitReached(quota.used['1080p'], quota.limits['1080p'])
                  ? 'var(--status-error)'
                  : '#fff',
              }}
            >
              {quota.used['1080p']} / {renderLimitValue(quota.limits['1080p'])}
            </strong>
          </div>

          <div>
            <span>4K: </span>
            {quota.limits['4K'] === 0 ? (
              <span
                style={{
                  color: 'var(--text-muted)',
                  fontSize: '11px',
                  background: 'rgba(255,255,255,0.03)',
                  padding: '1px 6px',
                  borderRadius: '4px',
                }}
              >
                Locked
              </span>
            ) : (
              <strong
                style={{
                  color: isLimitReached(quota.used['4K'], quota.limits['4K'])
                    ? 'var(--status-error)'
                    : '#fff',
                }}
              >
                {quota.used['4K']} / {renderLimitValue(quota.limits['4K'])}
              </strong>
            )}
          </div>

          {quota.limits['satellite'] !== undefined && quota.limits['satellite'] !== 0 && (
            <div>
              <span>MapTiler Satellite: </span>
              <strong
                style={{
                  color:
                    quota.limits['satellite'] !== -1 &&
                    quota.used['satellite'] !== undefined &&
                    quota.used['satellite'] >= (quota.limits['satellite'] ?? 0)
                      ? 'var(--status-error)'
                      : '#fff',
                }}
              >
                {quota.used['satellite']} / {renderLimitValue(quota.limits['satellite'] ?? 0)}
              </strong>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
